import {
  isShopCsMemoDeleteUnsupported,
} from '@shared/api/shopOrderCsMemo/shopOrderCsMemo.controller';
import {
  useCreateShopOrderCsMemo,
  useDeleteShopOrderCsMemo,
  useShopOrderCsMemoCache,
  useShopOrderCsMemoListQuery,
} from '@shared/api/shopOrderCsMemo/shopOrderCsMemo.hook';
import {
  ShopOrderCsMemo,
  ShopOrderCsMemoTarget,
} from '@shared/api/shopOrderCsMemo/shopOrderCsMemo.interface';
import { CsMemoAdapter, CsMemoRecord } from '@shared/components/csMemo';

// 공용 CS 메모 UI(@shared/components/csMemo)에 화환 주문 도메인 훅을 연결하는 어댑터.
// 화환은 타깃 축이 주문 하나뿐이라 단위 배지·서브 라벨이 필요 없다.

const useShopMemoList = (target: ShopOrderCsMemoTarget, enabled: boolean) => {
  const { data, isLoading } = useShopOrderCsMemoListQuery(target, enabled);
  return { data, isLoading };
};

const useShopMemoCache = (target: ShopOrderCsMemoTarget) =>
  useShopOrderCsMemoCache(target);

const useShopMemoCreate = () => {
  const mutation = useCreateShopOrderCsMemo();
  return {
    mutateAsync: (
      input: ShopOrderCsMemoTarget & { body: string; adminOnly?: boolean },
    ) => mutation.mutateAsync(input),
    isLoading: mutation.isLoading,
  };
};

const useShopMemoDelete = () => {
  const mutation = useDeleteShopOrderCsMemo();
  return {
    // 이 어댑터가 돌려준 메모만 들어오므로 도메인 타입으로 되돌려도 안전
    mutateAsync: ({ memo }: { memo: CsMemoRecord }) =>
      mutation.mutateAsync({ memo: memo as ShopOrderCsMemo }),
    isLoading: mutation.isLoading,
  };
};

export const shopOrderCsMemoAdapter: CsMemoAdapter<ShopOrderCsMemoTarget> = {
  useList: useShopMemoList,
  useCache: useShopMemoCache,
  useCreate: useShopMemoCreate,
  useDelete: useShopMemoDelete,
  isDeleteUnsupported: isShopCsMemoDeleteUnsupported,
  // 셀러 3롤은 "판매자" 하나로 뭉친다 (스펙 §2-3)
  roleBadge: (byRole) =>
    byRole === 'Admin'
      ? { label: '관리자', className: 'bg-indigo-100 text-indigo-700' }
      : { label: '판매자', className: 'bg-cyan-100 text-cyan-700' },
  hasTarget: (target) => !!target.shopOrder,
};

/** 구독만 끄기 위한 빈 타깃 */
export const SHOP_CS_MEMO_EMPTY_TARGET: ShopOrderCsMemoTarget = {};
